import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import PaymentSuccess from "./pages/PaymentSuccess";
import AdminPage from "./pages/AdminPage";
import PaymentMockupPreview from "./pages/PaymentMockupPreview";

// FASE 1 — marketplace rediseño
import HomePageV2 from "./v2/HomePage";
import EventsListPage from "./v2/EventsListPage";
import EventDetailPage from "./v2/EventDetailPage";
import VenueDetailPage from "./v2/VenueDetailPage";
import VenuesListPage from "./v2/VenuesListPage";
import TicketsPage from "./v2/TicketsPage";
import ProfilePage from "./v2/ProfilePage";
import CheckoutPage from "./v2/CheckoutPage";
// FASE 2 — filtros, perfil completo, entradas, ajustes
import AgePage from "./v2/AgePage";
import SavedVenuesPage from "./v2/SavedVenuesPage";
import SettingsPage from "./v2/SettingsPage";
import { PrivacyPage, TermsPage } from "./v2/LegalPages";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePageV2 />} />
          <Route path="/eventos" element={<EventsListPage />} />
          <Route path="/eventos/:id" element={<EventDetailPage />} />
          <Route path="/eventos/:id/comprar" element={<CheckoutPage />} />
          <Route path="/venues" element={<VenuesListPage />} />
          <Route path="/venues/:id" element={<VenueDetailPage />} />
          <Route path="/entradas" element={<TicketsPage />} />
          <Route path="/perfil" element={<ProfilePage />} />
          <Route path="/perfil/edad" element={<AgePage />} />
          <Route path="/perfil/guardadas" element={<SavedVenuesPage />} />
          <Route path="/perfil/ajustes" element={<SettingsPage />} />
          <Route path="/privacidad" element={<PrivacyPage />} />
          <Route path="/terminos" element={<TermsPage />} />

          <Route path="/classic" element={<div className="max-w-md mx-auto min-h-screen relative"><HomePage /></div>} />
          <Route path="/event/:eventId" element={<div className="max-w-md mx-auto min-h-screen relative"><HomePage /></div>} />
          <Route path="/payment-success" element={<div className="max-w-md mx-auto min-h-screen relative"><PaymentSuccess /></div>} />
          <Route path="/admin" element={<div className="max-w-md mx-auto min-h-screen relative"><AdminPage /></div>} />
          <Route path="/preview/payment" element={<div className="max-w-md mx-auto min-h-screen relative"><PaymentMockupPreview /></div>} />
          <Route path="/:slug" element={<div className="max-w-md mx-auto min-h-screen relative"><HomePage /></div>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
